<div class="tb">

  <!-- ═══ Barre d'état collante ═══ -->
  <div class="tb__bar">
    <div>
      <h1 class="tb__bar-title">{{ (isEdit() ? 'TEST_BUILDER.EDIT_TITLE' : 'TEST_BUILDER.TITLE') | translate }}</h1>
      <p class="tb__bar-sub">
        @if (subjectName()) {
          {{ subjectName() }} · {{ modeKey(mode()) | translate }}
        } @else {
          {{ 'TEST_BUILDER.PARAMS_SUB' | translate }}
        }
      </p>
    </div>

    <div class="tb__stats">
      <div class="tb__stat">
        <b>{{ picked().length }}</b>
        <span>{{ 'TEST_BUILDER.STAT_QUESTIONS' | translate }}</span>
      </div>
      <div class="tb__stat">
        <b>{{ totalPoints() }}</b>
        <span>{{ 'TEST_BUILDER.STAT_POINTS' | translate }}</span>
      </div>
      <div class="tb__stat">
        <b>{{ totalMinutes() }}</b>
        <span>{{ 'TEST_BUILDER.STAT_MINUTES' | translate }}</span>
      </div>
      <div class="tb__stat" [class.tb__stat--warn]="incomplete()">
        <b>{{ coveredCount() }}/{{ selectedThemeIds().length }}</b>
        <span>{{ 'TEST_BUILDER.STAT_CHAPTERS' | translate }}</span>
      </div>
    </div>

    <div class="tb__bar-actions">
      <!-- Un bouton gris sans explication se cherche longtemps : ici, la
           seule condition qu'on ne devine pas est le titulaire. -->
      @if (ownerMissing()) {
        <span class="tb__bar-warn">{{ 'TEST_BUILDER.OWNER_REQUIRED' | translate }}</span>
      }
      <button type="button" class="tb__btn" (click)="cancel()">
        {{ 'TEST_BUILDER.CANCEL' | translate }}
      </button>
      <button type="button" class="tb__btn tb__btn--primary"
              [disabled]="!canSubmit()" (click)="submit()">
        {{ (isEdit() ? 'TEST_BUILDER.SAVE' : 'TEST_BUILDER.SUBMIT') | translate }}
      </button>
    </div>
  </div>

  <main class="tb__wrap">

    <!-- ═══ Colonne principale ═══ -->
    <div class="tb__main">

      <!-- Paramètres -->
      <section class="tb__card">
        <div class="tb__card-head">
          <div>
            <h2>{{ 'TEST_BUILDER.PARAMS' | translate }}</h2>
            <p>{{ 'TEST_BUILDER.PARAMS_SUB' | translate }}</p>
          </div>
        </div>
        <div class="tb__card-body">
          <div class="tb__fields">
            <div class="tb__field">
              <label for="tb-path">{{ 'TEST_BUILDER.PATH' | translate }}</label>
              <select id="tb-path" [disabled]="loadingScope()"
                      (change)="onPathChange($any($event.target).value)">
                <option value="" [selected]="pathId() === null" disabled>
                  {{ (loadingScope() ? 'COMMON.LOADING' : 'TEST_BUILDER.PATH_PLACEHOLDER') | translate }}
                </option>
                @for (p of paths(); track p.id) {
                  <option [value]="p.id" [selected]="p.id === pathId()">{{ p.label }}</option>
                }
              </select>
            </div>

            <div class="tb__field">
              <label for="tb-subject">{{ 'TEST_BUILDER.SUBJECT' | translate }}</label>
              <select id="tb-subject" [disabled]="pathId() === null"
                      (change)="onSubjectChange($any($event.target).value)">
                <option value="" [selected]="subjectId() === null" disabled>
                  {{ 'TEST_BUILDER.SUBJECT_PLACEHOLDER' | translate }}
                </option>
                @for (s of subjects(); track s.id) {
                  <option [value]="s.id" [selected]="s.id === subjectId()">{{ s.label }}</option>
                }
              </select>
            </div>

            <!-- Un test appartient au professeur qui l'enseignera : il apparaît
                 dans sa liste, c'est lui qui l'ouvre et le valide. L'admin n'en
                 est pas un — l'écran envoyait pourtant son identité, et le test
                 partait sans titulaire réel. -->
            @if (isAdmin) {
              <div class="tb__field">
                <label for="tb-owner">{{ 'TEST_BUILDER.OWNER' | translate }}</label>
                <select id="tb-owner"
                        [disabled]="subjectId() === null || loadingProfessors()"
                        (change)="onOwnerChange($any($event.target).value)">
                  <option value="" [selected]="ownerId() === null" disabled>
                    {{ 'TEST_BUILDER.OWNER_PLACEHOLDER' | translate }}
                  </option>
                  @for (p of professors(); track p.id) {
                    <option [value]="p.id" [selected]="+p.id === ownerId()">
                      {{ professorLabel(p) }}
                    </option>
                  }
                </select>
                <small class="tb__owner-hint">
                  @if (subjectId() !== null && !loadingProfessors() && professors().length === 0) {
                    {{ 'TEST_BUILDER.OWNER_EMPTY' | translate }}
                  } @else {
                    {{ 'TEST_BUILDER.OWNER_HINT' | translate }}
                  }
                </small>
              </div>
            }

            <div class="tb__field tb__field--wide">
              <label for="tb-title">{{ 'TEST_BUILDER.TITLE_LABEL' | translate }}</label>
              <input id="tb-title" type="text"
                     [value]="title()"
                     (input)="title.set($any($event.target).value)"
                     [placeholder]="'TEST_BUILDER.TITLE_PLACEHOLDER' | translate">
            </div>

            <div class="tb__field tb__field--wide">
              <label for="tb-desc">{{ 'TEST_DETAIL.DESC_F' | translate }}</label>
              <textarea id="tb-desc" rows="2"
                        [value]="description()"
                        (input)="description.set($any($event.target).value)"
                        [placeholder]="'TEST_DETAIL.DESC_PLACEHOLDER' | translate"></textarea>
            </div>

            <div class="tb__field">
              <label for="tb-mode">{{ 'TEST_BUILDER.MODE' | translate }}</label>
              <select id="tb-mode" (change)="setMode($any($event.target).value)">
                @for (m of modes; track m) {
                  <option [value]="m" [selected]="m === mode()">{{ modeKey(m) | translate }}</option>
                }
              </select>
            </div>

            <div class="tb__field">
              <label for="tb-duration">{{ 'TEST_DETAIL.TIME_F' | translate }}</label>
              <input id="tb-duration" type="number" min="5"
                     [value]="timeLimitMinutes() ?? ''"
                     (input)="onNumber(timeLimitMinutes, $any($event.target).value)">
            </div>

            <div class="tb__field">
              <label for="tb-scale">{{ 'TEST_DETAIL.SCALE_F' | translate }}</label>
              <input id="tb-scale" type="number" min="1"
                     [value]="gradingScale() ?? ''"
                     (input)="onNumber(gradingScale, $any($event.target).value)"
                     placeholder="20">
              <small class="tb__hint">{{ 'TEST_DETAIL.SCALE_HINT' | translate }}</small>
            </div>

            <!-- Saisie sur le barème (10 sur 20), pas en pourcentage : c'est
                 l'unité du professeur. L'équivalent envoyé à l'API est affiché
                 dessous, pour que le seuil réel ne soit jamais implicite. -->
            <div class="tb__field">
              <label for="tb-pass">
                {{ 'TEST_DETAIL.PASS_F' | translate }}
                <span class="tb__unit">/ {{ gradingScale() ?? 20 }}</span>
              </label>
              <input id="tb-pass" type="number" min="0" [max]="gradingScale() ?? 20"
                     [value]="passingOnScale() ?? ''"
                     (input)="onNumber(passingOnScale, $any($event.target).value)"
                     [placeholder]="defaultPassing()">
              <small class="tb__hint">
                {{ 'TEST_DETAIL.PASS_HINT' | translate:{ percent: passingPercentage() } }}
              </small>
            </div>

            <div class="tb__field">
              <label for="tb-attempts">{{ 'TEST_DETAIL.ATTEMPT_F' | translate }}</label>
              <input id="tb-attempts" type="number" min="1"
                     [value]="maxAttempts() ?? ''"
                     (input)="onNumber(maxAttempts, $any($event.target).value)">
            </div>

            <div class="tb__field">
              <label for="tb-start">{{ 'DATA_TABLE.START_DATE' | translate }}</label>
              <input id="tb-start" type="datetime-local" [value]="startDate()"
                     (input)="startDate.set($any($event.target).value)">
            </div>

            <div class="tb__field">
              <label for="tb-end">{{ 'DATA_TABLE.END_DATE' | translate }}</label>
              <input id="tb-end" type="datetime-local" [value]="endDate()"
                     (input)="endDate.set($any($event.target).value)">
            </div>
          </div>

          <!-- Options du test. Le brouillage des questions et des réponses n'y
               figure plus : c'est une règle de passation depuis SKILL2ERA-117,
               tirée par séance, et ces deux interrupteurs ne pilotaient plus
               rien. Laissés à l'écran, ils auraient fait croire à un réglage. -->
          <div class="tb__switches">
            <app-switch-button [label]="'TEST_DETAIL.DISPR_F'" [checked]="showResultsImmediately()"
                               (toggled)="showResultsImmediately.set($event)"></app-switch-button>
            <app-switch-button [label]="'TEST_DETAIL.REVIEW_F'" [checked]="allowReview()"
                               (toggled)="allowReview.set($event)"></app-switch-button>
          </div>

          <div class="tb__chapters-block">
            <label>{{ 'TEST_BUILDER.CHAPTERS' | translate }}</label>
            <small>{{ 'TEST_BUILDER.CHAPTERS_HELP' | translate }}</small>

            @if (subjectId() === null) {
              <p class="tb__hint-inline">{{ 'TEST_BUILDER.CHOOSE_SCOPE' | translate }}</p>
            } @else {
              @if (chapters().length > 0) {
                <div class="tb__chips">
                  @for (c of chapters(); track c.id) {
                    <button type="button" class="tb__chip"
                            [attr.aria-pressed]="isChapterSelected(c.id)"
                            (click)="toggleChapter(c.id)">
                      {{ c.title }}
                    </button>
                  }
                </div>
              } @else {
                <p class="tb__hint-inline">{{ 'TEST_BUILDER.NO_CHAPTERS' | translate }}</p>
              }

              <!-- Saisie directe d'un module : créé à la volée s'il n'existe pas. -->
              <div class="tb__module-add">
                <input type="text" [value]="moduleDraft()"
                       (input)="moduleDraft.set($any($event.target).value)"
                       (keydown.enter)="addModule()"
                       [placeholder]="'TEST_BUILDER.ADD_MODULE_PLACEHOLDER' | translate"
                       [attr.aria-label]="'TEST_BUILDER.ADD_MODULE' | translate"
                       [disabled]="addingModule()">
                <button type="button" class="tb__btn tb__btn--sm"
                        [disabled]="!moduleDraft().trim() || addingModule()"
                        (click)="addModule()">
                  + {{ 'TEST_BUILDER.ADD_MODULE' | translate }}
                </button>
              </div>
            }
          </div>
        </div>
      </section>

      <!-- Questions du test -->
      <section class="tb__card">
        <div class="tb__card-head">
          <div>
            <h2>{{ 'TEST_BUILDER.PICKED' | translate }}</h2>
            <p>{{ 'TEST_BUILDER.PICKED_SUB' | translate }}</p>
          </div>
          <button type="button" class="tb__btn tb__btn--sm"
                  [disabled]="visibleBank().length === 0"
                  (click)="autoSelect()">
            ✨ {{ 'TEST_BUILDER.AUTO' | translate }}
          </button>
        </div>

        <div class="tb__picked">
          @if (picked().length === 0) {
            <div class="tb__empty">
              <i aria-hidden="true">📝</i>
              <b>{{ 'TEST_BUILDER.EMPTY_TITLE' | translate }}</b>
              {{ 'TEST_BUILDER.EMPTY_MSG' | translate }}
            </div>
          } @else {
            @for (p of picked(); track p.question.id; let i = $index) {
              <div class="tb__picked-row">
                <span class="tb__picked-num">{{ i + 1 }}</span>
                <span class="tb__picked-move">
                  <button type="button" [disabled]="i === 0" (click)="move(i, -1)"
                          [attr.aria-label]="'TEST_BUILDER.MOVE_UP' | translate">▲</button>
                  <button type="button" [disabled]="i === picked().length - 1" (click)="move(i, 1)"
                          [attr.aria-label]="'TEST_BUILDER.MOVE_DOWN' | translate">▼</button>
                </span>
                <span class="tb__picked-body">
                  <span class="tb__picked-title"><app-math-text [text]="p.question.title" [inline]="true"></app-math-text></span>
                  <span class="tb__picked-meta">
                    {{ chapterName(p.question.themeId) }} ·
                    {{ p.question.difficultyLevel }} ·
                    {{ p.question.questionType }}
                  </span>
                </span>
                <input class="tb__picked-pts" type="number" min="1"
                       [value]="p.points"
                       [attr.aria-label]="'TEST_BUILDER.POINTS_LABEL' | translate"
                       (input)="setPoints(p.question.id, $any($event.target).value)">
                <button type="button" class="tb__picked-del"
                        [attr.aria-label]="'BUTTONS.DELETE' | translate"
                        (click)="remove(p.question.id)">✕</button>
              </div>
            }
          }
        </div>
      </section>
    </div>

    <!-- ═══ Volet banque ═══ -->
    <aside class="tb__bank-wrap">
      <section class="tb__card">
        <div class="tb__card-head">
          <div>
            <h2>{{ 'TEST_BUILDER.BANK' | translate }}</h2>
            <p>{{ 'TEST_BUILDER.BANK_SUB' | translate }}</p>
          </div>
          <button type="button" class="tb__btn tb__btn--primary tb__btn--sm"
                  [disabled]="selectedThemeIds().length === 0"
                  (click)="openDrawer()">
            + {{ 'TEST_BUILDER.NEW' | translate }}
          </button>
        </div>
        <div class="tb__card-body">
          <label class="tb__search">
            <span aria-hidden="true">⌕</span>
            <input type="search"
                   [value]="search()"
                   (input)="onSearch($any($event.target).value)"
                   [placeholder]="'TEST_BUILDER.SEARCH' | translate">
          </label>

          <div class="tb__filters">
            @for (d of ['easy', 'medium', 'hard']; track d) {
              <button type="button" class="tb__chip"
                      [attr.aria-pressed]="difficultyFilter() === d"
                      (click)="toggleDifficulty(d)">
                {{ diffKey(d) | translate }}
              </button>
            }
          </div>

          <div class="tb__bank-list">
            @if (selectedThemeIds().length === 0) {
              <div class="tb__empty">
                <i aria-hidden="true">📚</i>
                <b>{{ 'TEST_BUILDER.BANK_NO_CHAPTER_TITLE' | translate }}</b>
                {{ 'TEST_BUILDER.BANK_NO_CHAPTER_MSG' | translate }}
              </div>
            } @else if (bankLoading()) {
              <div class="tb__empty">
                <i aria-hidden="true" class="tb__spin">⏳</i>
                {{ 'TEST_BUILDER.BANK_LOADING' | translate }}
              </div>
            } @else if (bankErrored()) {
              <div class="tb__empty">
                <i aria-hidden="true">⚠️</i>
                <b>{{ 'TEST_BUILDER.BANK_ERROR_TITLE' | translate }}</b>
                <button type="button" class="tb__btn tb__btn--sm" (click)="reloadBank()">
                  {{ 'TEST_BUILDER.BANK_ERROR_RETRY' | translate }}
                </button>
              </div>
            } @else if (visibleBank().length === 0) {
              <div class="tb__empty">
                <i aria-hidden="true">🔍</i>
                <b>{{ 'TEST_BUILDER.BANK_NONE_TITLE' | translate }}</b>
                {{ 'TEST_BUILDER.BANK_NONE_MSG' | translate }}
              </div>
            } @else {
              @for (q of visibleBank(); track q.id) {
                <button type="button" class="tb__qitem"
                        [attr.data-picked]="isPicked(q.id)"
                        (click)="togglePick(q)">
                  <span>
                    <span class="tb__qitem-title"><app-math-text [text]="q.title" [inline]="true"></app-math-text></span>
                    <span class="tb__qitem-meta">
                      <span class="tb__tag tb__tag--{{ q.difficultyLevel }}">{{ q.difficultyLevel }}</span>
                      <span class="tb__tag">{{ q.questionType }}</span>
                    </span>
                  </span>
                  <span class="tb__qitem-add">{{ isPicked(q.id) ? '✓' : '+' }}</span>
                </button>
              }
            }
          </div>
        </div>
      </section>
    </aside>

  </main>

  <!-- ═══ Tiroir : créer une question ═══ -->
  @if (drawerOpen()) {
    <div class="tb__drawer-back" (click)="closeDrawer()"></div>
    <aside class="tb__drawer" role="dialog" aria-modal="true">
      <div class="tb__drawer-head">
        <h2>{{ 'TEST_BUILDER.DRAWER_TITLE' | translate }}</h2>
        <button type="button" class="tb__btn tb__btn--ghost"
                [attr.aria-label]="'BUTTONS.CANCEL' | translate"
                (click)="closeDrawer()">✕</button>
      </div>
      <div class="tb__drawer-body">
        <div class="tb__field tb__field--wide">
          <label for="tb-drawer-chapter">{{ 'TEST_BUILDER.DRAWER_CHAPTER' | translate }}</label>
          <select id="tb-drawer-chapter"
                  (change)="onDrawerThemeChange($any($event.target).value)">
            @for (c of selectedChapters(); track c.id) {
              <option [value]="c.id" [selected]="c.id === drawerThemeId()">{{ c.title }}</option>
            }
          </select>
        </div>

        <p class="tb__drawer-hint">✱ {{ 'TEST_BUILDER.DRAWER_HINT' | translate }}</p>

        <!-- `evaluation` est le mode diagnostique : l'énumération serveur le dit
             (« Test diagnostique — الاختبار التشخيصي »), et c'est ce que
             compose l'import. Le nom vient de l'historique, pas du métier. -->
        <app-question-editor
          [diagnostic]="mode() === 'evaluation'"
          (save)="onQuestionCreated($event)"
          (cancel)="closeDrawer()">
        </app-question-editor>
      </div>
    </aside>
  }

</div>
